var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTether = function SvgTether(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.733,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.624 8.774v1.994l.002.002c3.639.17 6.374.907 6.374 1.785 0 .88-2.735 1.615-6.374 1.785v6.393h-3.242V14.34C6.742 14.168 4 13.434 4 12.553c0-.88 2.74-1.614 6.384-1.785V8.774H5.9V5.733h12.209v3.041h-4.485Zm0 5.018v.004c3.213-.146 5.61-.716 5.61-1.398 0-.682-2.395-1.252-5.61-1.399v2.228a18.25 18.25 0 0 1-1.594.051c-.834 0-1.438-.036-1.648-.051v-2.23c-3.218.145-5.623.717-5.623 1.399 0 .684 2.402 1.254 5.623 1.398v-.002c.208.01.795.035 1.633.035 1.047 0 1.518-.028 1.61-.035Z",
    fill: "#000"
  })));
};

export default SvgTether;